import { Button,  FormGroup, TextField, TableContainer, Table, TableHead, TableRow, TableCell, Paper, TableBody, Tabs, Tab } from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers';
import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { HolidayClient, } from '../../api/server';
import { useParams } from 'react-router-dom';
import GlobalHolidays from './GlobalHolidays';
import { ExtendedClient } from '../../api/ExtendedClient';


function CustomTabPanel(props) {
  const { children, value, index } = props;

  return (
    <div
      hidden={value !== index}
    >
      {value === index && (
        <>{children}</>
      )}
    </div>
  );
}

export default function HolidaysNew() {
  const [textToConvert, setTextToConvert] = useState("");
  const globalInfo = useSelector((state) => state.globalInfo)
  const [holidayName, setHolidayName] = useState("");

  const [isAddMode, setAddMode] = useState(false)
  const [isDateRangeMode, setRangeMode] = useState(false)
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

  let { currentPhoneNumberId } = useParams();

  const [holidayDateFrom, setHolidayDateFrom] = React.useState(null);
  const [holidayDateTo, setHolidayDateTo] = React.useState(null);
  const [holidays, setHolidays] = React.useState([]);

  function deleteHoliday(holidayId) {
    const client = (new ExtendedClient(HolidayClient)).getClient();
    
    client.deleteHoliday(holidayId).then(() => {
      reload();
    });

  }
  function addHoliday() {
    const client = (new ExtendedClient(HolidayClient)).getClient();

    //console.log({ currentCompanyId: globalInfo.currentCompanyId, currentPhoneNumberId, holidayName, holidayDateFrom, holidayDateTo: isDateRangeMode ? holidayDateTo : holidayDateFrom, textToConvert })
    
    client.addHolidayWithAudioText(globalInfo.currentCompanyId, currentPhoneNumberId, holidayName, holidayDateFrom, isDateRangeMode ? holidayDateTo : holidayDateFrom, textToConvert).then(() => {
      reload();

      clearForm();
      setAddMode(false)
    });

  }

  function clearForm() {
    setHolidayName("")
    setHolidayDateTo(null)
    setHolidayDateFrom(null)
    setRangeMode(false)
    setTextToConvert("")
  }

  function reload() {
    const client = (new ExtendedClient(HolidayClient)).getClient();;

    if (currentPhoneNumberId) {

      client.getHolidays(currentPhoneNumberId).then((data) => {
        setHolidays(data)
      })
    }
  }
  useEffect(() => {
    reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPhoneNumberId])


  function isFormInvalid() {
    if (!holidayName) return true;
    if (!textToConvert) return true;

    if (!holidayDateFrom) return true;

    if (isDateRangeMode && !holidayDateTo) return true;

  }

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function getUrl(path) {
    if (path.startsWith("https")) {
      return path
    }
    return process.env.REACT_APP_API_URL + "/" + path;
  }

  return (
    <>
      {!isAddMode && <>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Global Holidays/Greetings" />
          <Tab label="My Holidays/Greetings"></Tab>
        </Tabs>

        <CustomTabPanel value={value} index={1}>


          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={3}>
                    <h1>My Holidays/Greetings</h1>
                  </TableCell>
                  <TableCell>
                    <Button variant='outlined' onClick={() => { setAddMode(true) }} >Add Holiday/Greeting</Button>&nbsp;&nbsp;
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableHead>
                <TableRow>
                  <TableCell>
                    Date
                  </TableCell>
                  <TableCell>
                    Name
                  </TableCell>
                  <TableCell>
                    Audio
                  </TableCell>
                  <TableCell>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {holidays.map((row, index) => (
                  <React.Fragment key={row.holidayId}>
                    <TableRow >
                      <TableCell>
                        {
                          (new Date(row.fromDate.toString())).toLocaleDateString("en-us", options)
                        }
                        {
                          row.fromDate.toString() !== row.toDate.toString() && <>&nbsp; To &nbsp;
                            {
                              (new Date(row.toDate.toString())).toLocaleDateString("en-us", options)
                            }
                          </>
                        }
                      </TableCell>
                      <TableCell>
                        {row.holidayName}
                      </TableCell>
                      <TableCell>
                        {
                          row.audioFile &&
                          <figure style={{ marginLeft: -10 }}>
                            <audio
                              controls
                              src={getUrl(row.audioFile.path)}>
                              <a href={getUrl(row.audioFile.path)}>
                                Download audio
                              </a>
                            </audio>
                          </figure>
                        }
                      </TableCell>
                      <TableCell>
                        <Button variant='contained' onClick={() => { deleteHoliday(row.holidayId) }}>Delete</Button>
                      </TableCell>

                    </TableRow>

                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel >
        <CustomTabPanel value={value} index={0}>
          <GlobalHolidays onReload={reload}></GlobalHolidays>
        </CustomTabPanel >
      </>}
      {isAddMode && <>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={9} lg={8}>
            <div>
              <h1>Add Holiday/Greeting </h1>
              <FormGroup>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      required
                      fullWidth
                      label="Holiday/Greeting Name"
                      value={holidayName}
                      onChange={(event) => { setHolidayName(event.target.value) }}
                    />
                  </Grid>
                </Grid>
                <br></br>
                {
                  !isDateRangeMode &&
                  <Grid container spacing={2}>
                    <Grid item md={5}  >
                      <MobileDatePicker
                        label="Holiday/Greeting Date"
                        value={holidayDateFrom}
                        slotProps={{ textField: { fullWidth: true } }}
                        onChange={(newValue, context) => { if (context.validationError) { setHolidayDateFrom(null) } else { setHolidayDateFrom(newValue) }; }}
                      />
                    </Grid>
                    <Grid item md={2}>
                      <Button size='small' variant='outlined' onClick={() => { setRangeMode(!isDateRangeMode) }}>{!isDateRangeMode && <>Show</>}{isDateRangeMode && <>Hide</>} Date Range</Button>
                    </Grid>
                  </Grid>
                }
                {
                  isDateRangeMode && <Grid container spacing={2}>
                    <Grid item xs={5}  >
                      <MobileDatePicker
                        label="Holiday/Greeting Date From"
                        value={holidayDateFrom}
                        slotProps={{ textField: { fullWidth: true } }}
                        onChange={(newValue, context) => { if (context.validationError) { setHolidayDateFrom(null) } else { setHolidayDateFrom(newValue) }; }}
                      />
                    </Grid>
                    <Grid item xs={5}  >
                      <MobileDatePicker
                        label="Holiday/Greeting Date To"
                        value={holidayDateTo}
                        slotProps={{ textField: { fullWidth: true } }}
                        onChange={(newValue, context) => { if (context.validationError) { setHolidayDateTo(null) } else { setHolidayDateTo(newValue) }; }}
                      />
                      <br></br>
                    </Grid>
                    <Grid item xs={2}>
                      <Button size='small' variant='outlined' onClick={() => { setRangeMode(!isDateRangeMode) }}>{!isDateRangeMode && <>Show</>}{isDateRangeMode && <>Hide</>} Date Range</Button>
                    </Grid>

                  </Grid>
                }
                <br></br>
                <Grid container spacing={2}>
                  <Grid item md={6}  >
                    <TextField label={"Audio Message -Text will be Converted To Audio"} rows={10} fullWidth={true} multiline={true} value={textToConvert} onChange={(e) => { setTextToConvert(e.target.value) }}></TextField>
                  </Grid>
                </Grid>
                <br></br>
              </FormGroup>
            </div>
            <div>
              <h1>Add Holiday/Greeting</h1>
              <Button variant='contained' onClick={() => { addHoliday() }} disabled={isFormInvalid()} >Save Holiday/Greeting</Button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Button variant='contained' onClick={() => { setAddMode(false); clearForm(); }}>Close</Button>
            </div>
          </Grid>
        </Grid>
      </>}
    </>
  )
}
